import { z } from 'zod';

/**
 * Upper bound the UI imposes on a display name. The backend does not validate
 * it at all and the column is unbounded TEXT, so this is a product decision,
 * not a mirror of a server rule.
 */
export const NAME_MAX_LEN = 100;

/**
 * Same shape the backend accepts, mirrored so the form rejects exactly what
 * `Email::new` would (crates/sentinel-domain/src/value_objects/email.rs).
 */
const EMAIL_RE = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// Every message here is an i18n key in the `profile` namespace, translated at
// the render site — the account-section idiom (see disable-mfa-dialog.tsx).
export const nameSchema = z.object({
  name: z
    .string()
    .refine((v) => v.trim().length > 0, { message: 'name_required' })
    .refine((v) => v.trim().length <= NAME_MAX_LEN, { message: 'name_too_long' }),
});
export type NameInput = z.infer<typeof nameSchema>;

export const emailSchema = z.object({
  new_email: z.string().refine((v) => EMAIL_RE.test(v.trim()), { message: 'email_invalid' }),
});
export type EmailInput = z.infer<typeof emailSchema>;

export const passwordSchema = z
  .object({
    current_password: z.string().refine((v) => v.length > 0, { message: 'password_required' }),
    new_password: z.string().refine((v) => v.length > 0, { message: 'password_required' }),
    confirm_password: z.string().refine((v) => v.length > 0, { message: 'password_required' }),
  })
  .refine((d) => d.new_password === d.confirm_password, {
    path: ['confirm_password'],
    message: 'passwords_must_match',
  });
export type PasswordInput = z.infer<typeof passwordSchema>;
